import { GestorDashboardDateRangePicker } from '@/components/Gestores/GestorDashboardDateRangePicker'

type Props = {
  createdFrom: string
  createdTo: string
  disabled?: boolean
  onApply: (from: string, to: string) => void
}

export function GestorDashboardPeriodControls(props: Props) {
  return <GestorDashboardDateRangePicker {...props} />
}
